import React from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from 'hedron';
import OptionSelector from '../../components/OptionSelector';
import SizeGuide from '../../components/SizeGuide';

const InStockOptions = ({
  categories,
  currentCategoryId,
  color,
  department,
  handleSizeClick,
  onSelectorClick,
  isOutOfStock,
  s3BasePath,
  selectedOption,
  selectorOptions,
  selectorTitleText,
  shouldPulse
}) => (
  <Row>
    <Column fluid xs={7}>
      <OptionSelector
        color={color}
        disabled={isOutOfStock}
        handleClick={handleSizeClick}
        onSelectorClick={onSelectorClick}
        margin="0"
        options={selectorOptions}
        pulse={shouldPulse}
        s3BasePath={s3BasePath}
        selectedOption={selectedOption}
        textAlign={isOutOfStock ? 'center' : null}
        titleText={selectorTitleText}
        uppercase={isOutOfStock}
        width="100%"
        wrapperMargin="0"
      />
    </Column>
    <Column fluid xs={5}>
      <SizeGuide
        categories={categories}
        currentCategoryId={currentCategoryId}
        right
        department={department}
        s3BasePath={s3BasePath}
      />
    </Column>
  </Row>
);

InStockOptions.propTypes = {
  categories: PropTypes.string,
  currentCategoryId: PropTypes.string,
  color: PropTypes.string,
  department: PropTypes.string.isRequired,
  handleSizeClick: PropTypes.func.isRequired,
  onSelectorClick: PropTypes.func,
  isOutOfStock: PropTypes.bool,
  s3BasePath: PropTypes.string.isRequired,
  selectedOption: PropTypes.string.isRequired,
  selectorOptions: PropTypes.array.isRequired,
  selectorTitleText: PropTypes.string.isRequired,
  shouldPulse: PropTypes.bool.isRequired
};

export default InStockOptions;
